import React from 'react';

function Arrow() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 24 24">
      <path d="M12 0L9.885 2.115l8.37 8.385H0v3h18.255l-8.37 8.385L12 24l12-12z" />
    </svg>
  );
  /* eslint-enable */
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/common/icons/Arrow.js